window.selectedZelle = "";
window.oriClassName = "";
window.hoverClassName = "";
window.baseURL = "";
window.timer;                  //TODO: Aaron: missing () or =""; ???

var admin_kalender_anzeige = document.getElementById('admin_kalender_anzeige');

var Tandem = function () {
    this.dispo = {

    };
    this.init = function(callback){
        var thiz = this;
        console.log(' ----- initializing -----')
        this.dispo.timedRefresh(this.config.refreshTime);
        if(callback){
            callback
        }
        $("#links_admin").on("change", "#select_nummer", function(){
            thiz.dispo.updateVars(true);

        })
        console.log(thiz)
        $('#datumVon').pikaday({
            format: thiz.dispo.picker.formatDMY,
            reposition: false
        });
        $('#datumBis').pikaday({
            format: thiz.dispo.picker.formatDMY,
            reposition: false
        });
    };
    this.config = {
        url : location.href,
        actionPage : 'index.php?eID=',
        actionURL: '',
        baseUrl: '',
        refreshTime : 20 * 60 * 35
    };

    //this.config.refreshTime = 10;
    this.getBaseURL = function () {
        var baseURL = this.config.url.substring(0, this.config.url.indexOf("/", 14));

        if (baseURL.indexOf("http://localhost") != -1) {        //TODO: Aron !== ??
            var url = location.href;  // window.location.href;
            var pathname = location.pathname;  // window.location.pathname;
            var index1 = url.indexOf(pathname);
            var index2 = url.indexOf("/", index1 + 1);
            var baseLocalUrl = url.substr(0, index2);

            return baseLocalUrl + "/";
        } else {
            // Root Url for domain name
            return baseURL + "/";
        }
    };
    this.config.baseUrl = this.getBaseURL();
    this.config.actionURL = this.config.baseUrl + this.config.actionPage;
    console.log(this.config);

    this.dispo.tourDaten = {};

    this.dispo.tourDaten.lastState = {
    };
    if($('.user-disponent').length > 0) {
        if(document.getElementsByClassName("links_admin_fahrer")) {

        } else {
            this.dispo = {
                tourDaten:{
                    disponent : document.getElementById("disponent").value,
                    ziel : document.getElementById("ziel").value,
                    ziel_text : document.getElementById("ziel_text").value,
                    hotel : document.getElementById("hotel").value,
                    bemerkung : document.getElementById("bemerkung").value,
                    maxFahrer : document.getElementById("maxFahrer").value,
                    lfdnr : document.getElementById("lfdnr").value,
                    datumBis: document.getElementById("datumBis").value,
                    datumVon: document.getElementById("datumVon").value,
                    startzeit: document.getElementById("startzeit").value,
                    select_nummer : document.getElementById("select_nummer").value,
                    fz: document.getElementById("fz").value,
                    fahrer1: document.getElementById("fahrer1").value,
                    fahrer2: document.getElementById("fahrer2").value,
                    fahrer3: document.getElementById("fahrer3").value,
                    kalenderDatumVon: document.getElementById("kalenderStart").value,
                    kalenderDatumBis: document.getElementById("kalenderEnd").value,
                }
            };
        }

    } else if(document.getElementById("lfdnr") && $('.touren_overview_fahrer').length < 1){
        this.dispo = {
        tourDaten:{

            lfdnr: document.getElementById("lfdnr").value,
            kalenderDatumVon: document.getElementById("kalenderStart").value,
            kalenderDatumBis: document.getElementById("kalenderEnd").value,
            datumVon: document.getElementById("datumVon").value,
            nummer : document.getElementById("nummer").value,
            tourid : document.getElementById("tourid").value,
        }
        };
    }
    console.log(this);
    this.dispo = {

        //TODO: check Classes/Service/AbstractService to stay in-sync and keep this comment
        status : {
        success     : 200,
        forbidden   : 403,
        invalid     : 409,
        notfound    : 404
        },
        picker : {
            formatDMY: "DD.MM.YYYY",
            formatMY: "MM.YYYY"
        },
        actions:{
            edit_tour : this.config.actionURL +"edit_tour",
            check_tour : this.config.actionURL + "checkTour",
            save_tour : this.config.actionURL + "saveTour",
            delete_tour : this.config.actionURL + "deleteTour",
            hello_world : this.config.actionURL + "helloWorld",
            show_disptotafel: this.config.actionURL + "showDispotafel",
            fahrer_logs : this.config.actionURL + "fahrer_logs",
            show_disptotafel_zeile: this.config.actionURL + "showDispotafelZeile"
        },
        lastTourDaten:{},
        timedRefresh: function (time) {
            console.log("------- timed refresh ------");
            // alle 40 min nach dem window.load gibt es ein automatisches refresh, damit die Session nicht abgehängt wird
            var countdown = time;
            let thiz = this;
            if (document.getElementById("kalenderStart")) {
                // Dispotafel als Band

                setInterval(function () {
                    if (countdown === 0) {
                        refreshDispotafel();
                        countdown = time;
                    }
                    countdown--;
                }, 1000);
            } else {
                // 4-Wochentafel

                setInterval(function () {
                    if (countdown === 0) {
                        location.reload();
                    }
                    countdown--;
                }, 1000);
            }
        },
        showDispotafel: function (action) {
            console.log("---- show dispo -----");
            // Dispotafel -> das kalender band frisch machen
            var kalenderStart = "";
            if (document.getElementById("kalenderStart")) {
                kalenderStart = document.getElementById("kalenderStart").value;
            }
            var kalenderEnd = "";
            var kalenderEndQueryPart = "";
            if (document.getElementById("kalenderEnd")) {
                kalenderEnd = document.getElementById("kalenderEnd").value;
                kalenderEndQueryPart = "&kalenderEnd=" + kalenderEnd;
            } else {
                kalenderEndQueryPart = "";
            }
            //console.log (kalenderStart);
            document.body.style.cursor = "wait";
            $.get(action + "&kalenderStart=" + kalenderStart + kalenderEndQueryPart + "&rand=" + Math.random(),function(data){
                //console.log(req.responseText);
                //schreibe die antwort in den div container mit der id content
                document.body.style.cursor = "default";
                console.log(admin_kalender_anzeige);
                document.getElementById("rechts_admin").innerHTML = data;
                // document.getElementById("admin_kalender_anzeige").innerHTML = data;
                document.body.style.cursor = "default";
                makeDatePicker();
                if (document.getElementById("kalenderStartEingabe")) {
                    document.getElementById("kalenderStartEingabe").value = kalenderStart;
                }
                //alert(selectedZelle);
                if (document.getElementById(selectedZelle)) {
                    document.getElementById(selectedZelle).className = hoverClassName;
                }
            })
                .done(function () {
                    console.log('show Dispo Done');
                })
                .fail(function () {
                    console.log(' show dispo error')
                })

            // var req5 = createRequest();
            // req5.open("GET", action + "&kalenderStart=" + kalenderStart + kalenderEndQueryPart + "&rand=" + Math.random(), true);

            // req5.onreadystatechange = function () {
            //     switch (req5.readyState) {
            //         case 4:
            //             if (req5.status != this.status.success) {
            //                 console.log("Fehler:" + req5.status);
            //             } else {
            //                 //console.log(req.responseText);
            //                 //schreibe die antwort in den div container mit der id content
            //                 console.log(admin_kalender_anzeige);
            //                 document.getElementById("admin_kalender_anzeige").innerHTML = req5.responseText;
            //                 document.body.style.cursor = "default";
            //                 makeDatePicker();
            //                 if (document.getElementById("kalenderStartEingabe")) {
            //                     document.getElementById("kalenderStartEingabe").value = kalenderStart;
            //                 }
            //                 //alert(selectedZelle);
            //                 if (document.getElementById(selectedZelle)) {
            //                     document.getElementById(selectedZelle).className = hoverClassName;
            //                 }
            //             }
            //             break;
            //         default:
            //             return false;
            //             break;
            //     }
            // };
            // req5.send(null);

        },
        checkTour:function(){
            console.log("---- check tour -----");
            console.log(this);
            var thiz = this;

            // tour Speichern, aber vorher checken
            // gilt für 4-wochensicht und für das dispoband
            //alert("plausi check");
            document.body.style.cursor = "wait";

            // 1. Fahrer ist an diesem Tag schon verplant
            // 2. Tour überschneidet sich mit einem anderen, Soll andere Tour gelöscht werden?
            // 3. in der Anzeige ist die Zeile schon belegt

            var fahrer1 = document.getElementById("fahrer1").value,
            fahrer2 = document.getElementById("fahrer2").value,
            fahrer3 = document.getElementById("fahrer3").value;


            this.updateVars();
            var req = createRequest();
            req.open("GET", this.actions.check_tour + "&select_nummer=" + this.tourDaten.select_nummer + "&fz=" + this.tourDaten.fz + "&datum_von=" + this.tourDaten.datumVon + "&datum_bis=" + this.tourDaten.datumBis + "&fahrer1=" + fahrer1 + "&fahrer2=" + fahrer2 + "&fahrer2=" + fahrer2 + "&fahrer3=" + fahrer3 + "&lfdnr=" + this.tourDaten.lfdnr + "&rand=" + Math.random(), true);
            req.onreadystatechange = function () {
                switch (req.readyState) {
                    case 4:
                        if (req.status != thiz.status.success) {
                            console.log("Fehler:" + req.status);
                        } else {
                            // beim responsetext hängt hinten ein Leerzeichen dran!!!
                            //alert ("["+req.responseText+"]");
                            if (req.responseText === "OK") {
                                document.getElementById("button_save_tour_check").value = 1;
                                if (document.getElementById("modal_window").value === "1") {
                                    saveTourModal();
                                    return;
                                }
                                console.log("Tourchecked");
                                return true;
                            }

                            if (req.responseText === "FAHRER_OVERLAPPING") {
                                alert("Test: Bitte die Fahrer überprüfen! Einer der Fahrer ist schon für eine andere Tour verplant!");
                                return false;
                            }
                            if (req.responseText === "FAHRER_DUPLICAT") {
                                alert("Test: Bitte die Fahrer überprüfen! Einer der Fahrer ist für diese Tour doppelt verplant!");
                                return false;
                            }
                            if (req.responseText === "FAHRER_ABSENT") {
                                alert("Test: Bitte die Fahrer überprüfen! Einer der Fahrer ist an dem geplanten Tag nicht verfügbar!");
                                return false;
                            }
                            if (req.responseText === "TOUR_OVERLAPPING") {
                                alert("Test: Die Tour überschneidet sich mit einer anderen Tour mit diesem Wagen!");
                                return false;
                            }
                            if (req.responseText === "DISPLAY_NUMMER_OVERLAPPING") {
                                alert("Test: Die Tour überschneidet sich mit einer anderen Tour in der Anzeige! Bitte in einer anderen Zeile speichern!");
                                return false;
                            }
                            alert(req.responseText);
                        }
                        break;
                    default:
                        return false;
                        break;
                }
            };
            req.send(null);
            document.body.style.cursor = "default";
            if(req.onreadystatechange){
                return true;
            }
        },
        getRow: function(action, rowNumber, elemId,callback){
            console.log("------- GET Row(action: "+action+", rowNumber:"+rowNumber+") -------");
            console.log(action, rowNumber);
            var req = createRequest(),
                thiz = this;
            thiz.updateVars();
            console.log(action + "&zeile=" + rowNumber + "&datum_von=" + this.tourDaten.kalenderDatumVon + "&datum_bis=" + this.tourDaten.kalenderDatumBis + "&format=json" + "&rand="  + Math.random())
            req.open("GET", action + "&zeile=" + rowNumber + "&datum_von=" + this.tourDaten.kalenderDatumVon + "&datum_bis=" + this.tourDaten.kalenderDatumBis + "&format=json" + "&rand=" + Math.random(), true);

            req.onreadystatechange = function () {
                switch (req.readyState) {
                    case 4:
                        if (req.status != thiz.status.success) {
                            console.log("Fehler:" + req.status);
                        } else {

                            // var rows = document.getElementsByClassName("lkw-info"),
                            // respons = JSON.parse(req.responseText);
                            // console.log(rowNumber,respons);
                            // rows[rowNumber-1].outerHTML = respons.data;

                            var row = document.getElementById(elemId),
                            respons = JSON.parse(req.responseText);
                            console.log(rowNumber,respons,elemId);
                            row.outerHTML = respons.data;
                            if(callback){
                                callback;
                            }
                        }
                        break;
                    default:
                        return false;
                        break;
                }
            };
            req.send(null);
            document.body.style.cursor = "default";
            if(req.onreadystatechange){
                return true;
            }
        },
        reloadrows: function(){
            var thiz = this,
                action = thiz.actions.show_disptotafel_zeile;
            console.log("--- saveTour()->reloadrows(action:"+action+") called---");
            if(thiz.lastTourDaten){
                console.log(thiz.lastTourDaten.select_nummer);
            }

            console.log("--- reloadrows("+thiz.tourDaten.select_nummer+") ");

            // if (action === thiz.actions.save_tour){
            if(thiz.tourDaten.select_nummer === thiz.lastTourDaten.select_nummer || thiz.lastTourDaten.select_nummer === undefined){
                console.log("--- reloadrows("+thiz.tourDaten.select_nummer+") equal---");
                thiz.getRow(thiz.actions.show_disptotafel_zeile, thiz.tourDaten.select_nummer, 'lkw-info-'+thiz.tourDaten.select_nummer);
            }else if(thiz.tourDaten.select_nummer !== thiz.lastTourDaten.select_nummer ) {
                console.log("--- reloadrows("+thiz.tourDaten.select_nummer+") diff 1/2 ---");
                thiz.getRow(thiz.actions.show_disptotafel_zeile,thiz.tourDaten.select_nummer, 'lkw-info-'+thiz.tourDaten.select_nummer);
                console.log("--- reloadrows(action: "+thiz.actions.show_disptotafel_zeile+""+thiz.lastTourDaten.select_nummer+") diff 1/2 ---");
                thiz.getRow(thiz.actions.show_disptotafel_zeile,thiz.lastTourDaten.select_nummer, 'lkw-info-'+thiz.lastTourDaten.select_nummer);
            }

            console.log("--- reloadrows(action: "+thiz.actions.show_disptotafel_zeile+" displayAnwesend) ---");
            thiz.getRow(thiz.actions.show_disptotafel_zeile, 'displayAnwesend', 'displayAnwesend');

            // }
        },
        saveTour:function(action){
            console.log("---- saveTour(action: "+action+") -----");
            // console.log(this.tourDaten.select_nummer);
            var thiz = this;

            this.updateVars();
            //document.forms["eingabe"].action = action;
            //document.forms["eingabe"].submit();
            var submitForm = $("form[name=\"eingabe\"]");
            var actionUrl = "";
            var lfdnr = this.tourDaten.lfdnr;



            if(action == thiz.actions.delete_tour) {
                if(lfdnr==="") {
                    return false;
                }

                actionUrl = action + "&lfdnr=" + lfdnr + "&rand=" + Math.random();
            } else {
                actionUrl = action + "&startzeit=" + this.tourDaten.startzeit +"&bemerkung=" + this.tourDaten.bemerkung + "&ziel=" + this.tourDaten.ziel + "&ziel_text=" + this.tourDaten.ziel_text + "&hotel=" + this.tourDaten.hotel + "&disponent=" + this.tourDaten.disponent + "&select_nummer=" + this.tourDaten.select_nummer + "&fz=" + this.tourDaten.fz + "&datum_von=" + this.tourDaten.datumVon + "&datum_bis=" + this.tourDaten.datumBis + "&fahrer1=" + this.tourDaten.fahrer1 +  "&fahrer2=" + this.tourDaten.fahrer2 + "&fahrer3=" + this.tourDaten.fahrer3 + "&maxFahrer=" + this.tourDaten.maxFahrer + "&lfdnr=" + lfdnr + "&rand=" + Math.random();
            }

            console.log(this.tourDaten);

            $.ajax({
                url     : actionUrl ,
                type    : "POST",

                success : function( data ) {
                    console.log("about to call reloadrows()");
                    console.log(this);
                    //debugger;
                    //reloadrows();
                    thiz.reloadrows();

                    console.log(data);
                },
                error   : function( xhr, err ) {
                    console.log("Error Saving ");
                }
            });



        },
        confirmDeleteTour : function () {
            if (this.tourDaten.lfdnr!=="" && confirm("Soll die Tour wirklich gelöscht werden?") === true) {
                document.getElementById("button_delete_tour_confirm").value = 1;
                this.saveTour(this.actions.delete_tour);
                //document.forms["eingabe"].submit();
            }
            return false;
        },
        selectTour:function(divId, oriClassName_, hoverClassName_){
            console.log("---- select tour -----")
            // markieren der selektierten Zelle
            console.log("divID: "+ divId+ " | oriClassName_: "+ oriClassName_+ " | hoverClassName_: "+hoverClassName_);
            if (document.getElementById(selectedZelle)) {
                //document.getElementById(selectedZelle).className = oriClassName;
            }
            selectedZelle = divId;
            oriClassName = oriClassName_;
            hoverClassName = hoverClassName_;
            console.log(oriClassName);


        },
        showTour:function (action, nummer, lfdnr, datum) {
            console.log("---- show tour -----");
            var thiz = this;

            // eingabe formular für das dispo band füllen
            //alert(nummer + ": " + lfdnr);
            document.body.style.cursor = "wait";
            var kalenderStart = datum;
            if (document.getElementById("kalenderStart")) {
                kalenderStart = document.getElementById("kalenderStart").value;
            }
            var req4 = createRequest();
            thiz.updateVars();
            req4.open("GET", action + "&datum=" + datum + "&nummer=" + nummer + "&lfdnr=" + lfdnr + "&rand=" + Math.random(), true);

            req4.onreadystatechange = function () {
                switch (req4.readyState) {
                    case 4:
                        if (req4.status != thiz.status.success) {
                            //alert("Fehler:"+req4.status);
                        } else {
                            //alert(req4.responseText);
                            //schreibe die antwort in den div container mit der id content
                            if (document.getElementById("links_admin")) {
                                //alert("showTour 1: " + lfdnr);
                                $('#links_admin').css('left',$('#links_admin').css('left'));
                                var ele = $(req4.responseText);
                                console.log($('#links_admin').css('left'));
                                $('#links_admin #admin_eingabe_innen').replaceWith(ele.get(0));
                                // document.getElementById("links_admin").prepend(ele.get(0));
                                document.body.style.cursor = "default";
                                //if (document.getElementById("datumVon")) {
                                //makeDatePicker();
                                //}
                                //lfdnr =  document.getElementById("lfdnr").value;
                                //alert("showTour 1: " + lfdnr);

                                if (lfdnr == "" && document.getElementById("datumBis") != null) {
                                    document.getElementById("datumBis").value = document.getElementById("datumVon").value;
                                }
                                if (document.getElementById("kalenderStartEingabe")) {
                                    document.getElementById("kalenderStartEingabe").value = kalenderStart;
                                }
                                if (!document.getElementById("kalenderStart")) {
                                    document.getElementById("modal_window").value = "1";
                                }

                                $('#datumVon').pikaday({
                                    format: thiz.picker.formatDMY,
                                    reposition: false
                                });

                                $('#datumBis').pikaday({
                                    format: thiz.picker.formatDMY,
                                    reposition: false
                                });
                                if(window.isMobile) mobileAdminpanel.openMobilePanel();
                                thiz.updateVars();
                            }
                            return true;
                        }
                        break;
                    default:
                        return false;
                        break;
                }
            };
            req4.send(null);
            document.body.style.cursor = "default";

        },
        refreshDispotafel:function (config) {
            console.log("---- refresh dispotafel -----");

            //this.updateVars();

            showDispotafel();
            // console.log(config);
            // this.showTour(t.dispo.actions.edit_tour, config.fz, config.lfdnr, config.datumVon);
        },
        disableFahrerSelects:function (maxFahrer) {
            console.log("------disable faherer select ----");
            // die dropDowns müssen der fahreranzahl angepasst werden
            // alert(maxFahrer);
            var begin = parseInt(maxFahrer) + 1;
            for (var i = 1; i <= 3; i++) {
                if (i < begin) {
                    document.getElementById("fahrer" + i).disabled = false;
                } else {
                    document.getElementById("fahrer" + i).disabled = true;
                    document.getElementById("fahrer" + i).selectedIndex = 0;
                }
            }
        },
        fahrerLogs:function (action,lfdnr) {
            // fahrer / tour logs anzeigen
            // this.updateVars();
            var thiz = this;
            lfdnr = this.tourDaten.lfdnr;

            if(lfdnr==='') {
                console.log("Warning: no fahrerLog with empty lfdnr");
                return false;
            }

            var req3 = createRequest();
            req3.open("GET", action + "&lfdnr=" + lfdnr + "&rand=" + Math.random(), true);

            req3.onreadystatechange = function () {
                switch (req3.readyState) {
                    case 4:
                        if (req3.status != thiz.status.success) {
                            console.log("Fehler:" + req3.status);
                        } else {
                            alert(req3.responseText);
                        }
                        break;
                    default:
                        return false;
                        break;
                }
            };
            req3.send(null);
        },
        fahrerTagAbwesend:function (elem, datum, fahrerid, actionName) {
            // "ich-will" zeile füllen
            //alert("fahrer:" +actionName);

            if($(elem).attr('disable') == 'true'){
                console.log('disabled: '+$(elem).attr('disable'));
                return false;
            }

            var thiz = this;
            document.body.style.cursor = "wait";
            var tUIS = $(elem).attr('data-userid'),
                tDATE = $(elem).attr('data-datum');
            var actionURl,
                vButton = {
                    action: 'fahrerTagAbwesend(this,\''+tDATE+'\','+tUIS+', \'fahrer_abwesenheit_tag_delete\')',
                    text: 'Bist Du doch verfügbar?',
                    class: 'anwesend-confirm'
                },nvButton = {
                    action: 'fahrerTagAbwesend(this,\''+tDATE+'\','+tUIS+', \'fahrer_abwesenheit_tag\')',
                    text: 'Bist Du privat verhindert?',
                    class: 'anwesend-delete'
                };

            // var req3 = createRequest();
            actionURl = baseURL + "index.php?eID=" + actionName + "&fahrer=" + fahrerid + "&datumVon=" + datum + "&datumBis=" + datum + "&grund=N" + "&rand=" + Math.random();
            $(elem).attr('disable',true);


            $.ajax(actionURl)
                .done(function (data) {
                    console.log('fahrertoggle DoNE');
                    data = JSON.parse(data);
                    toggleAvail(data);
                    //debugger;
                    thiz.updateVars();

                })
                .always(function () {

                });

            // Change abwesend Status.
            // Achtung BUGANFÄLLIG
            function toggleAvail(data){
                let status = data.status,
                    message = data.message,
                    d = data.data;

                if(status.success){
                    if(d.absence !== true){
                        $(elem)
                            .attr('onclick',nvButton.action)
                            .html(nvButton.text)
                            .addClass(nvButton.class)
                            .removeClass(vButton.class)
                        console.log('Ab jetzt NICHT privat verhindert');
                    }else{
                        $(elem)
                            .attr('onclick',vButton.action)
                            .html(vButton.text)
                            .addClass(vButton.class)
                            .removeClass(nvButton.class)
                        console.log('Ab jetzt privat verhindert');
                    }
                    thiz.getRow(thiz.actions.show_disptotafel_zeile, 'displayAbwesend', 'displayAbwesend', $(elem).attr('disable','false'));
                }else{
                    alert(message);
                    $(elem).attr('disable',false);
                    return false;
                }

                // TODO: get abwesend Row
                // thiz.getRow(thiz.actions.show_disptotafel_zeile,12);
            }

            // req3.onreadystatechange = function () {
            //     var data = req3.responseText;
            //     switch (req3.readyState) {
            //         case 4:
            //             if(data == false){
            //                 if (req3.status != this.status.success) {
            //                     console.log("Fehler:" + req3.status);
            //                 } else {
            //
            //                     // doit
            //                     if (req3.responseText != 1) {
            //                         console.log(data);
            //                     }
            //                     //alert(req3.responseText);
            //
            //                 }
            //             } else{
            //
            //             }
            //
            //             break;
            //         default:
            //             return false;
            //             break;
            //     }
            // };
            // req3.send(null);
            document.body.style.cursor = "default";
        },
        updateVars: function (saveLastVars) {
            console.log("---- update vars -----");

            if(saveLastVars === true) {
                this.lastTourDaten = this.tourDaten;
            } else {

            }
            if($('.user-disponent').length > 0){
                this.tourDaten={
                    disponent : document.getElementById("disponent").value,
                    ziel : document.getElementById("ziel").value,
                    ziel_text : document.getElementById("ziel_text").value,
                    hotel : document.getElementById("hotel").value,
                    bemerkung : document.getElementById("bemerkung").value,
                    maxFahrer : document.getElementById("maxFahrer").value,
                    lfdnr : document.getElementById("lfdnr").value,
                    datumBis: document.getElementById("datumBis").value,
                    startzeit: document.getElementById("startzeit").value,
                    select_nummer : document.getElementById("select_nummer").value,
                    fz: document.getElementById("fz").value,
                    fahrer1: document.getElementById("fahrer1").value,
                    fahrer2: document.getElementById("fahrer2").value,
                    fahrer3: document.getElementById("fahrer3").value,
                    kalenderDatumVon: document.getElementById("kalenderStart").value,
                    kalenderDatumBis: document.getElementById("kalenderEnd").value,
                    datumVon: document.getElementById("datumVon").value,
                    };

            } else if(document.getElementById("lfdnr") && $('.touren_overview_fahrer').length < 1){
                this.tourDaten =
                    {
                        lfdnr: document.getElementById("lfdnr").value,
                        kalenderDatumVon: document.getElementById("kalenderStart").value,
                        kalenderDatumBis: document.getElementById("kalenderEnd").value,
                        datumVon: document.getElementById("datumVon").value,
                        nummer : document.getElementById("nummer").value,
                        tourid : document.getElementById("tourid").value,
                    };

            }

            console.log("------- Selected Tour");
            console.log(this.tourDaten);
            console.log("-------tour before");
            console.log(this.lastTourDaten);


        }
    };

};
var t = new Tandem();
t.init();
window.makeDatePicker = function(){
    var fahrerTafelEnd = new Pikaday({
            field: document.getElementById("fahrerTafelEnd"),
            format: t.dispo.picker.formatDMY,
            onSelect:function () {
                showFahrerTafel();
            }
        }),
        fahrerTafelStart = new Pikaday({
            field: document.getElementById("fahrerTafelStart"),
            format: t.dispo.picker.formatDMY,
            onSelect:function () {
                showFahrerTafel();
            }
        }),
        kalenderStart = new Pikaday({
            field: document.getElementById("kalenderStart"),
            format: t.dispo.picker.formatDMY,
            onSelect:function () {
                showDispotafel();
            }
        }),
        kalenderEnd = new Pikaday({
            field: document.getElementById("kalenderEnd"),
            format: t.dispo.picker.formatDMY,
            onSelect:function () {
                showDispotafel();
            }
        }),

        /*
            var field = document.getElementById('datepicker');
            var picker = new Pikaday({
                onSelect: function(date) {
                    field.value = moment(picker.toString()).format('YYYY/MM');
                }
            });
            field.parentNode.insertBefore(picker.el, field.nextSibling);
         */
        reportStart = new Pikaday({
            field: document.getElementById("reportStart"),
            format: t.dispo.picker.formatDMY,
            onSelect:function () {
                console.log('reportStart datePicker');
                //showDispotafel();
            }
        }),
        reportEnd = new Pikaday({
        field: document.getElementById("reportEnd"),
        format: t.dispo.picker.formatDMY,
        onSelect:function () {
            //showDispotafel();
        }
    })
        ;
        // picker_datumVon = new Pikaday({
        //     field: document.getElementById("datumVon"),
        //     format:"DD.MM.YYYY",
        //
        // }),

        // datumBis = new Pikaday({
        //     field: document.getElementById("datumBis"),
        //     format: t.picker.format,
        //
        // });

};
makeDatePicker();
// New Object Methods used
//TODO: include in Pagetemplates
window.selectTour = function (divId, oriClassName_, hoverClassName_) {
   t.dispo.selectTour(divId, oriClassName_, hoverClassName_);
};

window.refreshDispotafel = function() {
   t.dispo.refreshDispotafel(t.dispo.tourDaten);
};

window.showTour = function(nummer, lfdnr, datum) {
    t.dispo.showTour(t.dispo.actions.edit_tour,nummer, lfdnr, datum);
};
window.checkTourBeforeSave = function () {
    console.log("----check before save-----");
    if(t.dispo.checkTour() === true){

        t.dispo.saveTour(t.dispo.actions.save_tour);
    }
};
window.confirmDeleteTour = function () {
    t.dispo.confirmDeleteTour();
};

window.disableFahrerSelects = function(maxFahrer) {
    t.dispo.disableFahrerSelects(maxFahrer);
};

window.fahrerLogs = function(lfdnr) {
    t.dispo.fahrerLogs(t.dispo.actions.fahrer_logs,lfdnr);
};
// Pure Old STuff
//TODO: implement in tandem Object & include in Pagetemplates

window.fahrerAnfragen = function() {
    // alle fahrer mit einem Schlag anfragen
    document.body.style.cursor = "wait";
    var datum = document.getElementById("datumVon").value;
    var lfdnr = document.getElementById("lfdnr").value;
    var nummer = document.getElementById("nummer").value;
    var fz = document.getElementById("fz_name").value;
    var tourid = document.getElementById("tourid").value;

    if(lfdnr==='' || tourid==='') {
        return false;
    }

    var req2 = createRequest();
    req2.open("GET", baseURL + "index.php?eID=fahrer_anfrage_mail&tourid=" + tourid + "&datum=" + datum + "&fz=" + fz + "&lfdnr=" + lfdnr + "&rand=" + Math.random(), true);
    console.log(t);
    req2.onreadystatechange = function () {
        switch (req2.readyState) {
            case 4:
                if (req2.status != t.dispo.status.success) {
                    console.log("Fehler:" + req2.status);
                } else {
                    // anzeigen
                    //alert(req2.responseText);
                    if (document.getElementById("kalenderStart")) {
                        showDispotafel();
                    }
                    showTour(nummer, lfdnr, datum);
                }
                break;
            default:
                return false;
                break;
        }
    };
    req2.send(null);
    //showTour(fz, lfdnr, datum);
    //showDispotafel();
    document.body.style.cursor = "default";
};

window.fahrerAction = function(fz, tourid, datum, fahrerid, lfdnr, actionName) {
    // diverse Aktionen für einen einzigen fahrer erledigen
    document.body.style.cursor = "wait";
    datum = document.getElementById("datumVon").value;
    lfdnr = document.getElementById("lfdnr").value;
    fz = document.getElementById("fz_name").value;
    tourid = document.getElementById("tourid").value;
    var nummer = document.getElementById("nummer").value;

    var req3 = createRequest();
    req3.open("GET", baseURL + "index.php?eID=" + actionName + "&lfdnr=" + lfdnr + "&fahrer=" + fahrerid + "&datum=" + datum + "&fz=" + fz + "&tourid=" + tourid + "&rand=" + Math.random(), true);

    req3.onreadystatechange = function () {
        switch (req3.readyState) {
            case 4:
                if (req3.status != t.dispo.status.success) {
                    console.log("Fehler:" + req3.status);
                } else {
                    // doit
                    if (req3.responseText != 1) {
                        console.log(req3.responseText);
                    }

                    if (document.getElementById("kalenderStart")) {
                        showDispotafel();
                    }
                    if(actionName == 'fahrer_interest' || actionName == 'fahrer_interest_delete'){
                        t.dispo.getRow(t.dispo.actions.show_disptotafel_zeile,t.dispo.tourDaten.select_nummer,'lkw-info-'+t.dispo.tourDaten.select_nummer)
                    }
                    showTour(nummer, lfdnr, datum);
                    //alert("fahrerAction 2: " + actionName + " " + nummer + " " + lfdnr + " " + datum + " " + selectedZelle + " " + oriClassName);
                }
                break;
            default:
                return false;
                break;
        }
    };
    req3.send(null);
    document.body.style.cursor = "default";
};

window.fahrerTagInteresse = function(datum, fahrerid, actionName) {
    // "ich-will" zeile füllen
    //alert("fahrer:" +actionName);
    document.body.style.cursor = "wait";

    var req3 = createRequest();
    req3.open("GET", baseURL + "index.php?eID=" + actionName + "&fahrer=" + fahrerid + "&datum=" + datum + "&rand=" + Math.random(), true);

    req3.onreadystatechange = function () {
        switch (req3.readyState) {
            case 4:
                if (req3.status != t.status.success) {
                    console.log("Fehler:" + req3.status);
                } else {
                    // doit
                    if (req3.responseText != 1) {
                        console.log(req3.responseText);
                    }
                    //alert(req3.responseText);
                    showDispotafel();
                }
                break;
            default:
                return false;
                break;
        }
    };
    req3.send(null);
    document.body.style.cursor = "default";
};

window.clickHandler = function(Ereignis) {
    // verstehe ich nicht, wozu diese funktion gut sein soll
    // makeDatePicker();
};

window.showDispotafel=function() {
    t.dispo.showDispotafel(t.dispo.actions.show_disptotafel);
};


///////////////////////////////
////// DEPRICATED /////////////
///////////////////////////////

function saveTourModal() {
    // Fortsetzung für den speichervorgang, speziell für die 4-wochensicht
    tourid = document.getElementById("tourid").value;
    datumVon = document.getElementById("datumVon").value;
    datumBis = document.getElementById("datumBis").value;
    startzeit = document.getElementById("startzeit").value;
    nummer = document.getElementById("select_nummer").value;
    fz = document.getElementById("fz").value;
    fahrer1 = document.getElementById("fahrer1").value;
    fahrer2 = document.getElementById("fahrer2").value;
    fahrer3 = document.getElementById("fahrer3").value;
    disponent = document.getElementById("disponent").value;
    ziel = document.getElementById("ziel").value;
    ziel_text = document.getElementById("ziel_text").value;
    hotel = document.getElementById("hotel").value;
    bemerkung = document.getElementById("bemerkung").value;
    maxFahrer = document.getElementById("maxFahrer").value;
    lfdnr = document.getElementById("lfdnr").value;

    query = "";
    query = query + "&tourid=" + tourid;
    query = query + "&datumVon=" + datumVon;
    query = query + "&datumBis=" + datumBis;
    query = query + "&startzeit=" + startzeit;
    query = query + "&nummer=" + nummer;
    query = query + "&fz=" + fz;
    query = query + "&fahrer1=" + fahrer1;
    query = query + "&fahrer2=" + fahrer2;
    query = query + "&fahrer3=" + fahrer3;
    query = query + "&disponent=" + disponent;
    query = query + "&ziel=" + encodeURIComponent(ziel);
    query = query + "&ziel_text=" + ziel_text;
    query = query + "&hotel=" + hotel;
    query = query + "&bemerkung=" + bemerkung;
    query = query + "&maxFahrer=" + maxFahrer;
    query = query + "&lfdnr=" + lfdnr;
    //alert("query: "+query);
    //alert(encodeURIComponent(query));
    //query = encodeURIComponent(query);
    var req = createRequest();
    req.open("GET", baseURL + "index.php?eID=saveTourModal" + query + "&rand=" + Math.random(), true);

    req.onreadystatechange = function () {
        switch (req.readyState) {
            case 4:
                if (req.status != t.dispo.status.success) {
                    console.log("Fehler:" + req.status);
                } else {
                    // beim responsetext hängt hinten ein Leerzeichen dran!!!
                    if (req.responseText === 1) {
                        //alert("gespeichert");
                        self.close();
                        return;
                    }
                    console.log(req.responseText);
                }
                break;
            default:
                return false;
                break;
        }
    };
    req.send(null);
    document.body.style.cursor = "default";

}
window.showTourModal = function(nummer, lfdnr, datum) {
    if (window.showModalDialog) {
        // eingabe formular für die 4-wochensicht
        window.showModalDialog(baseURL + "admin/Toureingabe/?datum=" + datum + "&nummer=" + nummer + "&lfdnr=" + lfdnr + "&rand=" + Math.random(), null, "dialogWidth:440px; dialogHeight:750px; status:no; center:yes; resizable:yes; scroll:no;");
        //window.showModalDialog(baseURL+"admin/Toureingabe/?datum="+datum+"&nummer="+nummer+"&lfdnr="+lfdnr, null, "dialogWidth:500px; dialogHeight:700px; status:no; center:yes; resizable:yes; scroll:no;");
        location.reload();
    }
};





////////////////////////////
// ab hier FahrerTafel
///////////////////////////
window.tableLength = "";
window.fahrerTafelTableLength = "";
window.fahrerSelectAction = function(rowNumber, fahrerId) {
    var kalenderStart = "",
    fahrerTafelStart,
    fahrerTafelEnd;
    if (document.getElementById("fahrerTafelStart")) {
        fahrerTafelStart = document.getElementById("fahrerTafelStart").value;
    }
    if (document.getElementById("fahrerTafelEnd")) {
        fahrerTafelEnd = document.getElementById("fahrerTafelEnd").value;
    }
    // fahrer / fahrer_tafel zeile aktualisieren
    // alert("fahrerSelectAction: " + rowNumber + ", fahrerId: " + fahrerId);
    tableLength = document.getElementById("fahrerTafelTable").rows.length;
    if (tableLength === (rowNumber + 1)) {
        // addAuswahlRowAction();
        addTafelRowAction();
    }
    var req3 = createRequest();

    if(fahrerId !== '0'){
        console.log("-----fahrerselection: "+ baseURL + "index.php?eID=fahrerSelected&fahrerid=" + fahrerId + "&rownumber=" + rowNumber + "&fahrerTafelStart"+fahrerTafelStart+ "&fahrerTafelEnd" + fahrerTafelEnd + "&rand=" + Math.random());
        req3.open("GET", baseURL + "index.php?eID=fahrerSelected&fahrerid=" + fahrerId + "&rownumber=" + rowNumber + "&rand=" + Math.random(), true);
    }else{
        // console.log("-----fahrerselection: "+ baseURL + "index.php?eID=fahrerSelected&fahrerid=" + fahrerId + "&rownumber=" + rowNumber + "&fahrerTafelStart"+fahrerTafelStart+ "&fahrerTafelEnd" + fahrerTafelEnd + "&rand=" + Math.random());
        req3.open("GET", baseURL + "index.php?eID=removeFahrerSelect&rownumber=" + rowNumber + "&rand=" + Math.random(), true);
        //debugger;
        var rowTafel = document.getElementById('fahrerTafelTable').deleteRow(rowNumber);
        // var rowAuswahlTafel = document.getElementById('fahrerAuswahlTable').deleteRow(rowNumber);

    }
    req3.onreadystatechange = function () {
        switch (req3.readyState) {
            case 4:
                if (req3.status != t.dispo.status.success) {
                    console.log("Fehler:" + req3.status);
                } else {
                    //alert("fahreTR"+rowNumber);
                    if(fahrerId !== '0') document.getElementById("fahreTR" + rowNumber).innerHTML = req3.responseText;

                    console.log("onreadeystatechange: ");
                    console.dir(document.getElementById("fahreTR" + rowNumber));
                    showFahrerTafel();
                }
                break;
            default:
                return false;
                break;
        }
    };
    req3.send(null);

};


window.showFahrerTafel = function() {
    // Fahrertafel -> das Fahrer band frisch machen
    var kalenderStart = "",
    fahrerTafelStart,
    fahrerTafelEnd;
    if (document.getElementById("fahrerTafelStart")) {
        fahrerTafelStart = document.getElementById("fahrerTafelStart").value;
    }
    if (document.getElementById("fahrerTafelEnd")) {
        fahrerTafelEnd = document.getElementById("fahrerTafelEnd").value;
    }
    //alert (kalenderStart);
    document.body.style.cursor = "wait";
    var req5 = createRequest();
    console.log("--------------- Showfahreratfel: " + baseURL + "index.php?eID=showFahrerTafel&fahrerTafelStart=" + fahrerTafelStart + "&fahrerTafelEnd=" + fahrerTafelEnd + "&rand=" + Math.random(), true)
    req5.open("GET", baseURL + "index.php?eID=showFahrerTafel&fahrerTafelStart=" + fahrerTafelStart + "&fahrerTafelEnd=" + fahrerTafelEnd + "&rand=" + Math.random(), true);

    req5.onreadystatechange = function () {
        switch (req5.readyState) {
            case 4:
                if (req5.status != t.dispo.status.success) {
                    console.log("Fehler:" + req5.status);
                } else {
                    console.log('ShowFahreratfel')
                    //schreibe die antwort in den div container mit der id content
                    //document.getElementById("admin_kalender_anzeige").innerHTML = req5.responseText;
                    document.getElementById("rechts_admin_fahrer").innerHTML = req5.responseText;
                    document.body.style.cursor = "default";
                    makeDatePicker();

                    if (document.getElementById("fahrerTafelStart")) {
                        document.getElementById("fahrerTafelStart").value = fahrerTafelStart;
                        console.log(fahrerTafelStart);
                    }
                    if (document.getElementById("fahrerTafelEnd")) {
                        document.getElementById("fahrerTafelEnd").value = fahrerTafelEnd;
                        console.log(fahrerTafelEnd);

                    }
                    //alert(selectedZelle);
                    if (document.getElementById(selectedZelle)) {
                        document.getElementById(selectedZelle).className = hoverClassName;
                    }
                }
                break;
            default:
                return false;
                break;
        }
    };
    req5.send(null);
    document.body.style.cursor = "default";
};


window.addAuswahlRowAction = function() {

    var fahrerAuswahlTableLength = document.getElementById("fahrerTafelTable").rows.length;
    var rowAuswahl = document.getElementById("fahrerTafelTable").insertRow(tableLength);


    var req3 = createRequest();
    console.log(baseURL + "index.php?eID=addFahrerSelect&rownumber=" + tableLength + "&rand=" + Math.random());
    req3.open("GET", baseURL + "index.php?eID=addFahrerSelect&rownumber=" + tableLength + "&rand=" + Math.random(), true);

    req3.onreadystatechange = function () {
        switch (req3.readyState) {
            case 4:
                if (req3.status != t.dispo.status.success) {
                    console.log("Fehler:" + req3.status);
                } else {
                    rowAuswahl.innerHTML = req3.responseText;
                }
                break;
            default:
                return false;
                break;
        }
    };
    req3.send(null);
};


window.addTafelRowAction = function() {

    var fahrerTafelTableLength = document.getElementById("fahrerTafelTable").rows.length;
    var rowTafel = document.getElementById("fahrerTafelTable").insertRow(fahrerTafelTableLength);


    var req3 = createRequest();
    console.log(baseURL + "index.php?eID=addFahrerTafel&rownumber=" + fahrerTafelTableLength + "&rand=" + Math.random());
    req3.open("GET", baseURL + "index.php?eID=addFahrerTafel&rownumber=" + fahrerTafelTableLength + "&rand=" + Math.random(), true);

    req3.onreadystatechange = function () {
        switch (req3.readyState) {
            case 4:
                if (req3.status != t.dispo.status.success) {
                    console.log("Fehler:" + req3.status);
                } else {
                    //alert("addTafelRowAction " + req3.responseText);
                    rowTafel.outerHTML = req3.responseText;
                }
                break;
            default:
                return false;
                break;
        }
    };
    req3.send(null);

};



/////////////////////////////////
// allgemeine funktionen
///////////////////////////////////


window.createRequest=function() {
    // allgemeiner ajax kram
    //erstellen des requests
    var req = null;
    try {
        req = new XMLHttpRequest();
        //req.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8")
        //req.setRequestHeader("Content-Type", "text/html");
    } catch (ms) {
        try {
            req = new ActiveXObject("Msxml2.XMLHTTP");
        } catch (nonms) {
            try {
                req = new ActiveXObject("Microsoft.XMLHTTP");
            } catch (failed) {
                req = null;
            }
        }
    }
    if (req === null) console.log("Error creating request object!");
    return req;
};


//
// window.makeDatePicker=function() {
//     // kalender für dies und das fertigmachen
//     if (document.getElementById("kalenderStart")) {
//         new Pikaday({
//             useMode: 2,
//             field: document.getElementById("kalenderStart"),
//             dateFormat: "%d.%m.%Y"
//         });
//     }
//
//     if (document.getElementById("fahrerTafelStart")) {
//         new JsDatePick({
//             useMode: 2,
//             target: "fahrerTafelStart",
//             dateFormat: "%d.%m.%Y"
//         });
//     }
//     if (document.getElementById("fahrerTafelEnd")) {
//         new JsDatePick({
//             useMode: 2,
//             target: "fahrerTafelEnd",
//             dateFormat: "%d.%m.%Y"
//         });
//     }
//
//
//     if (document.getElementById("datumVon")) {
//         new JsDatePick({
//             useMode: 2,
//             target: "datumVon",
//             dateFormat: "%d.%m.%Y"
//         });
//     }
//
//     if (document.getElementById("datumBis")) {
//         new JsDatePick({
//             useMode: 2,
//             target: "datumBis",
//             dateFormat: "%d.%m.%Y"
//             /*selectedDate:{				This is an example of what the full configuration offers.
//              day:5,						For full documentation about these settings please see the full version of the code.
//              month:9,
//              year:2006
//              },
//              yearsRange:[1978,2020],
//              limitToToday:false,
//              cellColorScheme:"beige",
//              dateFormat:"%m-%d-%Y",
//              imgPath:"img/",
//              weekStartDay:1*/
//         });
//     }
// }

// ------------------ Script vonn Aaron hinzugefügt, zur erweiterung der Dispotafel
// recycelte funktion fahrerTagInteresse. Fahrer sollen sich selbst als abwesend kenzeichnen können
// Grund wird als Privat (N) gesendet


window.fahrerTagAbwesend=function(elem,datum, fahrerid, actionName) {
    t.dispo.fahrerTagAbwesend(elem,datum, fahrerid, actionName);
};

//
// $(document).ready(function(){
//     function fixtableheader(){
//         var dispotafel = document.getElementById("dispotafel"),
//             tbody = dispotafel.firstElementChild,
//             firstline = tbody.firstElementChild,
//             admin_kalender_anzeige = document.getElementById("admin_kalender_anzeige"),
//             topAbstand = $('.tandemDatePicker').height();
//
//         var clone = firstline.cloneNode(true);
//         var div = document.createElement("div");
//         var index;
//
//         while (clone.firstChild) {
//             div.appendChild(clone.firstChild);
//         }
//
//         for (index = clone.attributes.length - 1; index >= 0; --index) {
//             div.attributes.setNamedItem(clone.attributes[index].cloneNode());
//         }
//
//         console.log(clone);
//         admin_kalender_anzeige.appendChild(clone);
//         clone.parentNode.replaceChild(div, clone);
//
//         admin_kalender_anzeige.style.position = "relative";
//
//         div.style.position = "absolute";
//         div.style.top = topAbstand +"px";
//         div.style.left = 0 +"px";
//         div.style.background = "#eaeaea";
//         // div.style.padding = "0 7px";
//
//         window.addEventListener("scroll", function(){
//             var docScrolltop = document.documentElement.scrollTop;
//             if(docScrolltop > (topAbstand + $('header').height() + 5)){
//                 div.style.top = (docScrolltop) - $('header').height() -10 +"px";
//             } else {
//                 div.style.top = topAbstand +"px";
//             }
//         });
//
//     };
//     if(document.getElementById("dispotafel")){
//         fixtableheader();
//     }
// })
//
//
//






// WEBPACK FOOTER //
// ./js/fahrer_bem_ajax.js